<template>
  <div id="app">
    <div class="header-container">
      <m-header></m-header>
    </div>
    <router-view/>
    <div class="footer-container">
      <m-footer></m-footer>
    </div>
  </div>
</template>

<script>
// 模块
import MHeader from '@/components/header/header'
import MFooter from '@/components/footer/footer'

export default {
  name: 'App',
  components: {
    MHeader,
    MFooter
  }
}
</script>

<style scoped lang="less">
  @import "assets/css/variable";
  .header-container {
    height: 80px;
    line-height: 80px;
    box-shadow: 0 2px 13px rgba(0,0,0,.05);
  }
  .footer-container {
    background-color: @color-theme;
    padding: 50px 0px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue